function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17,17 C16.447,17 16,16.552 16,16 C16,15.448 16.447,15 17,15 C17.553,15 18,15.448 18,16 C18,16.552 17.553,17 17,17 L17,17 Z M5,5 C5.552,5 6,5.448 6,6 C6,6.552 5.552,7 5,7 C4.448,7 4,6.552 4,6 C4,5.448 4.448,5 5,5 L5,5 Z M18,7 C18,4.794 16.206,3 14,3 C11.794,3 10,4.794 10,7 L10,15 C10,16.103 9.103,17 8,17 C6.897,17 6,16.103 6,15 L6,8.815 C7.336,8.339 8.245,6.955 7.941,5.4 C7.711,4.225 6.743,3.269 5.565,3.052 C3.664,2.703 2,4.161 2,6 C2,7.302 2.839,8.401 4,8.815 L4,15 C4,17.206 5.794,19 8,19 C10.206,19 12,17.206 12,15 L12,7 C12,5.897 12.897,5 14,5 C15.103,5 16,5.897 16,7 L16,13.185 C14.664,13.661 13.755,15.045 14.059,16.601 C14.289,17.776 15.257,18.732 16.435,18.948 C18.337,19.297 20,17.839 20,16 C20,14.698 19.161,13.599 18,13.185 L18,7 Z"
});

var SvgSteps = function SvgSteps(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgSteps;